/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Viewroledescription3Inputs */

const en_usermanagement_permissions_viewroledescription3 = /** @type {(inputs: Usermanagement_Permissions_Viewroledescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View your permissions based on the role of`)
};

/**
* | output |
* | --- |
* | "View your permissions based on the role of" |
*
* @param {Usermanagement_Permissions_Viewroledescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_viewroledescription3 = /** @type {((inputs?: Usermanagement_Permissions_Viewroledescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Viewroledescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_viewroledescription3(inputs)
});
export { usermanagement_permissions_viewroledescription3 as "userManagement_permissions_viewRoleDescription" }